import { SCREEN } from '../../utils/constants';
import {
    categories,
    procedures,
    setSelectedCategoryId,
} from '../../utils/variables';
import { selectCategory } from '../actions/categorySelectionActions';
import { navigate } from './movePages';
import { loadCategories } from '../../views/components/category';
import { loadProcedures } from '../../views/components/procedures';

export function categorySelectionListeners() {
    document.querySelectorAll('.categories__list .category-item').forEach((i) => {
        i.addEventListener('click', handleSelectCategory);
    });
}

export function handleSelectCategory(selectedCategory = null) {
    let categoryId;
    if (selectedCategory && typeof selectedCategory === 'number') {
        categoryId = selectedCategory;
    } else {
        categoryId = parseInt(this.getAttribute('data-category-id'));
    }
    selectCategory(categoryId);
    setSelectedCategoryId(categoryId);

    const selectedCategoryObj = categories.find(c => c.id == categoryId);
    if (!selectedCategoryObj) return;

    const filteredProcedures = procedures.filter(procedure => {
        return procedure.service_categories
            ?.map(cat => cat.id)
            .includes(categoryId);
    });

    loadCategories(filteredProcedures);
    loadProcedures(filteredProcedures);
    navigate(SCREEN.SEE_ALL_SERVICES);
}

